import { getRequestv1 } from './api.service'

type Product = {
  id?: string
  brand?: {
    createdDate?: any
    id?: string
    lastModifiedDate?: any
    name?: string
    status?: string
    url?: string
  }
  createdDate?: any
  details?: string
  documents?: {
    createdDate?: any
    id?: string
    name?: string
    storageFileName?: string
    url?: string
  }[]
  externalId?: string
  lastModifiedDate?: any
  status?: string
  title?: string
  subtitle?: string
  images?: {
    createdDate?: any
    id?: string
    name?: string
    storageFileName?: string
    url?: string
  }[]
}

export async function getProductById(id: string, cancelPendingRequest?: boolean): Promise<Product> {
  const endpoint = `/v1/products/${id}`
  const response = await getRequestv1(endpoint, cancelPendingRequest)
  return response?.data
}
